import { screenRotationDeg } from "./viewport";

/**
 * CSS transform for a placed symbol's glyph. A symbol's stored rotation is
 * degrees counter-clockwise in the metres frame; CSS rotate() is clockwise,
 * so the angle is flipped here once. `scale` carries the hover enlargement in
 * the same string so the rotation can never be dropped from it.
 */
export const symbolTransform = (rotationCcw, scale = 1) =>
  `scale(${scale}) rotate(${screenRotationDeg(rotationCcw ?? 0)}deg)`;
